import React, { useEffect } from "react";
import Cookies from "js-cookie";
import { useNavigate, useLocation } from "react-router-dom";
import { useLocalStorage } from "usehooks-ts";

const ProjectUidHandler = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [user] = useLocalStorage("user", null);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const projectUid = params.get("project_uid");
        const cookieProjectUid = Cookies.get("ai_id");

        //if (projectUid || cookieProjectUid) {
        //    if (projectUid) Cookies.set("ai_id", projectUid);
        //    params.delete("project_uid");
        //    if (user && location.pathname !== "/pro/builder/create") {
        //        navigate("/pro/builder/create");
        //    }
        //}
    }, [location, navigate, user]);

    return null;
};

export default ProjectUidHandler;
